import _ from 'lodash';
import validator from 'validator';

class FormValidator {
    constructor(validations) {
        this.validations = validations;
    };

    validate(state) {
        let validation = this.valid();

        if (this.validations) {
            this.validations.forEach(rule => {
                if (!validation[rule.field].isInvalid) {

                    let state_field_value = state[rule.field];
                    if (rule.field.includes('.')) {
                        let current = state;
                        const fieldNameParts = rule.field.split('.');
                        for (let i = 0; i < fieldNameParts.length - 1; i++) {
                            if (!current[fieldNameParts[i]]) {
                                current[fieldNameParts[i]] = {};
                            }
                            current = current[fieldNameParts[i]];
                        }
                        const fieldName = fieldNameParts[fieldNameParts.length - 1];
                        state_field_value = current[fieldName];
                    }

                    const field_value = (state_field_value !== null && state_field_value !== undefined) ? state_field_value.toString() : '';
                    const args = rule.args || [];
                    const validation_method = typeof rule.method === 'string' && rule.method !== 'custom' ? validator[rule.method] : rule.method;

                    if (rule.allowBlank && field_value === '') { return validation; }

                    if (validation_method !== 'custom') {
                        if (validation_method(field_value, ...args, state) !== rule.validWhen) {
                            validation[rule.field] = {
                                isInvalid: true,
                                message: rule.message
                            };

                            validation.isValid = false;
                        }
                    } else {
                        if (!_.isFunction(rule.fn)) {
                            console.error("Custom validator rule not defined.");
                            validation.isValid = false;
                        } else {
                            if (rule.fn(field_value, state, ...args) !== rule.validWhen) {
                                validation[rule.field] = {
                                    isInvalid: true,
                                    message: rule.message
                                };

                                validation.isValid = false;
                            }
                        }
                    }
                }
            });
        }

        return validation;
    };

    valid() {
        const validation = {}

        if (this.validations) {
            this.validations.map(rule => (
                validation[rule.field] = { isInvalid: false, message: '' }
            ));
        }

        return { isValid: true, ...validation };
    };
};

export default FormValidator;
